export default "__VITE_PUBLIC_ASSET__7f003806__"